const questionWraps = document.querySelectorAll('.question-wrap');
let currentExpandedNavbarHeight;

questionWraps.forEach((question) => {
    question.addEventListener('click', function(){
        let arrowIcon = this.firstElementChild.firstElementChild;
        let dataAttrValue = this.getAttribute('data-display-answer');        
        let answerWrap = document.getElementById(dataAttrValue);
        if(answerWrap.style.maxHeight) {            
            answerWrap.style.maxHeight = null;
        } else {
            answerWrap.style.maxHeight = answerWrap.scrollHeight + 'px';
        }
        if(arrowIcon.classList.contains('mdi-arrow-up-drop-circle')) {
            arrowIcon.classList.replace('mdi-arrow-up-drop-circle', 'mdi-arrow-down-drop-circle');
        } else if(arrowIcon.classList.contains('mdi-arrow-down-drop-circle')) {
            arrowIcon.classList.replace('mdi-arrow-down-drop-circle', 'mdi-arrow-up-drop-circle');
        }
        
    });
});